
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.25 18.75v1.5a1.5 1.5 0 0 1-1.5 1.5h-4.5m0-18h4.5a1.5 1.5 0 0 1 1.5 1.5v1.5m-9.86 16.49-9-1.24a.75.75 0 0 1-.64-.75V3.72A.75.75 0 0 1 1.34 3l9-2.22a.75.75 0 0 1 .91.73v21a.74.74 0 0 1-.86.73Zm9.86-13.49 3 3H15m5.25 3 3-3","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.38 11.62A.38.38 0 0 0 7 12a.38.38 0 0 0 .75 0 .38.38 0 0 0-.37-.38","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    